import React from 'react';
import {
  addButton,
  button,
  card,
  cardHeader,
  cardNumber,
  dangerButton,
  hint,
} from '../../../shared/ui/formStyles';

// Список однотипных блоков (пункт методики, результат, факт, рядок списка).
// Каждый элемент — карточка с кнопками «Вище», «Нижче», «Видалити»;
// содержимое рисует renderItem, а порядок и добавление живут здесь.
const ItemsEditor = ({
  items,
  onChange,
  renderItem,
  createItem,
  itemName = 'пункт',
  addLabel,
  description,
  emptyText,
  min = 0,
}) => {
  const list = Array.isArray(items) ? items : [];

  const replace = (index, nextItem) =>
    onChange(list.map((item, i) => (i === index ? nextItem : item)));

  const move = (from, to) => {
    if (to < 0 || to >= list.length) return;
    const next = [...list];
    const [moved] = next.splice(from, 1);
    next.splice(to, 0, moved);
    onChange(next);
  };

  const remove = (index) => {
    if (!window.confirm(`Видалити ${itemName} ${index + 1}?`)) return;
    onChange(list.filter((_, i) => i !== index));
  };

  return (
    <div>
      {description && <p style={{ ...hint, margin: '0 0 10px' }}>{description}</p>}

      {list.length === 0 && emptyText && (
        <p style={{ ...hint, margin: '0 0 10px', fontStyle: 'italic' }}>{emptyText}</p>
      )}

      {list.map((item, index) => (
        <div key={index} style={card}>
          <div style={cardHeader}>
            <span style={cardNumber}>
              {`${itemName.charAt(0).toUpperCase()}${itemName.slice(1)} ${index + 1}`}
            </span>
            <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
              <button type="button" style={button} onClick={() => move(index, index - 1)}>
                Вище
              </button>
              <button type="button" style={button} onClick={() => move(index, index + 1)}>
                Нижче
              </button>
              {list.length > min && (
                <button type="button" style={dangerButton} onClick={() => remove(index)}>
                  Видалити
                </button>
              )}
            </div>
          </div>

          {renderItem(item, (nextItem) => replace(index, nextItem), index)}
        </div>
      ))}

      <button
        type="button"
        style={{ ...addButton, width: '100%' }}
        onClick={() => onChange([...list, createItem(list.length)])}
      >
        + {addLabel || `Додати ${itemName}`}
      </button>
    </div>
  );
};

export default ItemsEditor;
